export default __webpack_public_path__ + "static/media/direct_order_image.3cf50566.jpg";